import { useTranslation } from 'next-i18next'

import onboardAnalytics from '~/analytics/onboarding/onboardAnalytics'
import HelpToggleButton from '~/bootcamp/pages/BootcampView/BootcampPageHelp/HelpToggleButton'
import { HelpToggleType } from '~/bootcamp/types/bootcamp.types'

import Button from '~/components/Buttons/Button'

import MethodCard from '~/onboarding/components/MethodCard'
import { setShowHomMethodsActionCreator } from '~/onboarding/redux/onboarding.slice'
import { useAppDispatch } from '~/redux/hooks'
import { homMethodsProps } from '~/shared/types/studyTips.types'

export default function HomMethods(props: homMethodsProps): React.ReactElement {
  const { t } = useTranslation('onboarding')

  const dispatch = useAppDispatch()
  const onClick = (): void => {
    dispatch(setShowHomMethodsActionCreator(false))
    onboardAnalytics.logHomMethodsPopup(false)
  }

  const homMethods = props.data

  return homMethods ? (
    <div className="fixed flex flex-col items-center bg-black/80 p-4 isolate z-top w-screen h-screen">
      <div className="absolute flex w-12 h-12 justify-center items-center mt-2">
        <HelpToggleButton
          className="w-full h-full cursor-default"
          onClick={() => {}}
          toggleType={HelpToggleType.homMethods}
        />
      </div>
      <div className="my-8 max-w-screen-19/20 md:max-w-196 p-2 md:min-w-196 bg-gradient-dashboard rounded-3xl border-white border-2 overflow-hidden">
        <div className="h-full w-full p-6 md:p-12 mx-auto overflow-y-auto util-scrollbar shop-scrollbar ">
          <div className="w-full">
            <h1 className="text-white text-4xl font-bold text-center">{homMethods.title}</h1>
          </div>
          <div className="flex justify-center w-full my-4">
            <p className="text-white text-center text-sm">{homMethods.description}</p>
          </div>
          {homMethods?.methods?.length > 0 &&
            homMethods.methods.map((item, index) => (
              <MethodCard
                description={item.description}
                index={index}
                key={item.title}
                srcKey={item.icon?.srcKey}
                title={item.title}
              />
            ))}

          <div className="flex justify-center mt-12">
            <Button
              className="border-2 min-w-54 border-white text-white bg-purple hover:scale-110 duration-300"
              onClick={onClick}
              size="medium"
            >
              {t('ok')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div />
  )
}
